import { makeStyles, Typography } from '@material-ui/core';

const year = new Date().getFullYear();

export const Footer = () => {
  const classes = useStyles();
  const copyrightText = `© ${year} TRUPER S.A. de C.V. Todos los derechos reservados.`;
  return (
    <Typography className={classes.footer} variant="caption">
      {copyrightText}
    </Typography>
  );
};

const useStyles = makeStyles(theme => ({
  footer: {
    alignSelf: 'center',
    color: '#232322',
    fontFamily: 'Roboto',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
    letterSpacing: -0.408,
  },
}));
